import { useSyncExternalStore } from 'react';

export type NavigationMode = 'sidebar' | 'bottom';
const key = 'worki.navigation.mode';
const event = 'worki-navigation-mode';
export function navigationMode(): NavigationMode {
  try { return localStorage.getItem(key) === 'bottom' ? 'bottom' : 'sidebar'; } catch { return 'sidebar'; }
}
export function setNavigationMode(mode: NavigationMode): void {
  try { localStorage.setItem(key, mode); } catch { /* The current device may disallow storage. */ }
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(event));
}
function subscribe(update: () => void) {
  window.addEventListener(event, update); window.addEventListener('storage', update);
  return () => { window.removeEventListener(event, update); window.removeEventListener('storage', update); };
}
export function useNavigationMode() {
  return useSyncExternalStore(subscribe, navigationMode, () => 'sidebar' as const);
}
